import React, { createContext, useEffect, useReducer, useState } from 'react'
import { toast } from 'react-toastify';
import app from '../db/firebase';
export const StarterContext = createContext()
const initialState = [];
function Starter({ children }) {
    const [auth, setauth] = useState({
        loading: true,
        login: false,
        user: {}
    })
    console.log(auth);
    const text = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque odio asperiores voluptate excepturi quod eveniet expedita dicta commodi reiciendis ullam!";
    const image = `https://source.unsplash.com/collection/${ Math.ceil(Math.random() * 1000) }/1600x900`
    const tourPlan = [
        {
            name: "prantho",
            img: image,
            description: text

        },
        {
            name: "Shoccho",
            img: image,
            description: text
        },
        {
            name: "Good Boy",
            img: image,
            description: text
        },
    ]
    const reducer = (state, { type, payload }) => {
        switch (type) {
            case "ADD_TODO":
                state = [...state, payload];
                return state;
            case "REMOVE_TODO":
                state = state.filter((todo, i) => {
                    return i !== payload
                });
                toast.error('Todo Removed')
                return state
            default:
                return state;
        }
    }
    const [state, dispatch] = useReducer(reducer, initialState)

    const todoAdd = (todoInput) => {
        dispatch({ type: "ADD_TODO", payload: todoInput })
    }
    const todoDelete = (e) => {
        dispatch({ type: "REMOVE_TODO", payload: e })
    }
    const signIn = ({ user }) => {
        setauth({
            loading: false,
            login: true,
            user: user
        })
    }
    const signOut = () => {
        app.auth().signOut();
        setauth({
            loading: true,
            login: false,
            user: {}
        })
    }
    const authCheck = () => {
        app.auth().onAuthStateChanged(function (user) {
            if (user) {
                setauth({
                    loading: false,
                    login: true,
                    user: user
                })
            } else {
                setauth({
                    loading: true,
                    login: false,
                    user: {}
                })
            }
        });
    }
    useEffect(() => {
        authCheck()
    }, [])
    return (
        <>
            <StarterContext.Provider value={{ state, todoAdd, todoDelete, tourPlan, signIn, auth, signOut }}>
                {children}
            </StarterContext.Provider>
        </>
    )
}

export default Starter
